
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.914 12.586l-3.328 3.328a2 2 0 01-1.415.586h-7.67a2 2 0 01-2-2v-11a2 2 0 012-2h11a2 2 0 012 2v7.671c0 .53-.212 1.04-.587 1.415z"}}),_c('path',{attrs:{"d":"M11.5 16.473V13.5a2 2 0 012-2h2.973M5.667 4.333v9.333M3.667 6H13M3.667 9H13m-9.333 3H9"}})])])
          )
        }
      }
    